import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";

function App() {
  return (
    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
